import type {TacticalPlanResponseType} from "./TacticalPlanApi";


export class TacticalPlan {

    private tacticalPlan: TacticalPlanResponseType | null = null;
    private count_vehicle: number = 0;
    private count_map: number = 0;

    public constructor(tacticalPlan: TacticalPlanResponseType | null) {
        this.tacticalPlan = tacticalPlan;
    }

    public getId(): number | null {
        return this.tacticalPlan?.id ?? null;
    }

    public set(tacticalPlan: TacticalPlanResponseType): void {
        this.tacticalPlan = tacticalPlan;
    }

    public _get(): TacticalPlanResponseType | null {
        return this.tacticalPlan;
    }

    public getWeekSchedule(): number {
        return this.tacticalPlan?.week_schedule ?? 0;
    }

    public setWeekSchedule(weekSchedule: number): void {
        if (this.tacticalPlan) {
            this.tacticalPlan.week_schedule = weekSchedule;
        }
    }

    public getName(): string {
        return this.tacticalPlan?.name ?? '';
    }


    public setCountVehicle(count: number): void {
        this.count_vehicle = count;
    }

    public getCountVehicle(): number {
        return this.count_vehicle;
    }

    public setCountMap(count: number): void {
        this.count_map = count;
    }

    public getCountMap(): number {
        return this.count_map;
    }


}